import { createAction, props } from "@ngrx/store";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";

const actionName = "[ ObterArquivoPdfNoticia ] Obter arquivo Pdf noticia";

export const obterArquivoPdfNoticia = createAction(
  actionName,
  props<{ inputDto: string}>()
);

export const obterArquivoPdfNoticiaSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoDadosOutputDto<string> }>()
);

export const obterArquivoPdfNoticiaFailure = createAction(
  `${actionName} - Falha`,
  props<{ response: EstruturaRetornoDadosOutputDto<string> }>()
);

export const obterArquivoPdfNoticiaFinish = createAction(
  `${actionName} - Concluir`
);
